import { isNonEmptyArray } from '@/utils/checks'
import { Center } from '@/types/models'
import getTypeTittleMapFromLocationList from '../location/useCases/getTypeTitleMapFromLocationList'
import { Location } from '../../types/models/Location.model'
import { getLocations } from '../center'

type PageViewProperties = {
  path: string
  url: string
  city?: string
  country?: string
  region?: string
  title?: string
  search: string
  template: string
  br?: Center['br']
  sponsor_tier?: Center['sponsor_tier']
}
interface GeneratePageViewProperties {
  (props: { center?: Center }): PageViewProperties
}

const generatePageViewPropertiesForCenter: GeneratePageViewProperties = ({
  center
}) => {
  const defaultProperties: PageViewProperties = {
    path: window.location.pathname,
    search: window.location.search,
    url: window.location.href,
    template: 'CenterProfile',
    title: document.title,
    sponsor_tier: center?.sponsor_tier,
    br: center?.br
  }

  const centerLocations: Location[] = getLocations(center)

  if (!isNonEmptyArray(centerLocations)) {
    return defaultProperties
  }

  return {
    ...defaultProperties,
    ...getTypeTittleMapFromLocationList(centerLocations)
  }
}

export default generatePageViewPropertiesForCenter
